import { render, staticRenderFns } from "./centerSet.vue?vue&type=template&id=3005f78e&scoped=true"
import script from "./centerSet.vue?vue&type=script&lang=js"
export * from "./centerSet.vue?vue&type=script&lang=js"
import style0 from "./centerSet.vue?vue&type=style&index=0&id=3005f78e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3005f78e",
  null
  
)

export default component.exports